(function(window, document, $){
  'use strict';

var setupSmoothScroll = function(){

  var $window = $(window),
    $document = $(document),
    $main = $('html, body'),
    $navBar = $('.navigation-bar-wrapper'),
    minDuration = 700,
    rate = 6000;

  var isWithinView = function (selector) {
    var $element = $(selector).first().filter(':visible'),
      offset = $element.offset(),
      eleTop,
      eleHeight,
      winTop,
      winHeight,
      navBarOffset,
      adjustment;

    if (!offset) {
      return false;
    }

    eleTop = offset.top;
    eleHeight = $element.outerHeight();
    winTop = $window.scrollTop();
    winHeight = $window.height();

    navBarOffset = $navBar.offset();

    if (navBarOffset && navBarOffset.top === winTop) {
      adjustment = $navBar.outerHeight();
      winTop += adjustment;
      winHeight -= adjustment;
    }

    return winTop <= eleTop && winTop + winHeight >= eleTop + eleHeight;
  };

  var scrollTo = function (selector) {
    var $element = $(selector).first().closest(':visible'),
      offset = $element.offset(),
      $combo,
      isAfterNavBar,
      adjustment,
      offsetTop,
      distance,
      duration;
    
    if (!offset) {
      return false;
    }

    $combo = $element.add($navBar);
    isAfterNavBar = $combo.index($navBar) === 0;
    adjustment = isAfterNavBar ? $navBar.height() : 0;
    offsetTop = offset.top - adjustment;
    distance = Math.abs($window.scrollTop() - offsetTop);
    duration = Math.max(minDuration, Math.round(distance * 1000 / rate));
    
    setTimeout(function () {
      $main.animate({
        scrollTop: offsetTop
      }, duration);
    }, 1);

    return true;
  };

  var scrollToWindowHash = function () {
    var hash = window.location.hash;
    if (!hash) {
      return;
    }
    scrollTo(hash);
  };

  // "Export" smooth scroll features/utilities
  window.smoothScroll = {
    isWithinView: isWithinView,
    scrollTo: scrollTo,
    scrollToWindowHash: scrollToWindowHash
  };

  if (!$main.hasClass('smooth-scroll-enabled')) {
    return;
  }

  // Fire smooth-scroll 'on ready' as quickly as possible
  scrollToWindowHash();

  // Listen for the URL changing (manual or other means)
  $window.on('hashchange', scrollToWindowHash);

  $document.on('click.smooth-scroll', 'a[href*="#"]:not([href="#"])', function (e) {
    var anchor = e.currentTarget,
      $target;

    if (e.isDefaultPrevented() || !(location.hostname === anchor.hostname && location.pathname === anchor.pathname)) {
      return;
    }

    $target = $(anchor.hash);

    if (!$target.length) {
      $target = $('a[name="' + anchor.hash.slice(1) + '"]');
    }

    if (scrollTo($target)) {
      e.preventDefault();

      if (window.history && window.history.pushState) {
        window.history.pushState({}, document.title, anchor.href);
      }
    }
  });

  $document.on('click.video-auto-scroll', '.video-trigger', function (e) {
    var $container = $(e.currentTarget).closest('.video-star, .hero');

    if (!isWithinView($container)) {
      scrollTo($container);
    }
  });
};

// Init
$(setupSmoothScroll);

})(window, document, jQuery);
